





















import Vue from "vue";
export default Vue.extend({

    props: {
        imgLocation: {
            type: String,
            required: false,
            default: ""
        },
        imgAlt: {
            type: String,
            required: false,
            default: ""
        }
    },

    computed: {
        imgSrcLocation: function() {
            return require(`@/assets/${this.imgLocation}.svg`);
        }
    }
});
